<div class="card-wrapper k-mt-10">
  <div class="card">
    <div class="card-body">
      <app-planner />
    </div>
  </div>
</div>
